<template>
    <div class="container-tooltip" @mouseleave="leave">
        <transition name="my-transition">
            <div
                class="content-tooltip"
                v-show="tooltip && showTooltip && mouseOverType === variant.type && !hideTooltip"
                @mouseleave="leave"
                :style="{ '--tooltipWidth': tooltipWidth + 'px' }"
            >
                {{ tooltip }}
            </div>
        </transition>
        <div v-if="variant" @mouseenter="enter" class="button-container" ref="buttonContainer">
            <router-link
                v-if="variant.type != 'info-vns'"
                :class="className"
                :to="link"
                @click.native="scrollTop"
            >
                <action :small="true" :name="name" :selected="selected">
                    {{ label }}
                </action>
            </router-link>
            <a v-if="variant.type == 'info-vns'" :class="className" @click="openInfoVns">
                <action :small="true" :name="name">{{ label }}</action>
            </a>
        </div>
    </div>
</template>

<script>
import { EventBus } from "src/bus/eventBus";
import scrollManager from "src/components/convention/managers/scrollManager.js";

export default {
    components: {},
    data() {
        return {
            showTooltip: false,
            tooltipWidth: 0,
        };
    },
    mounted() {
        this.tooltipWidth = this.$refs.buttonContainer.offsetWidth + 13;
    },
    props: ["convention", "variant", "selected", "mode", "mouseOverType", "hideTooltip"],
    computed: {
        label() {
            return this.$privateDico.convention.type[this.variant.type];
        },
        tooltip() {
            return this.$privateDico.convention.typeTooltip[this.variant.type];
        },
        link() {
            return `/espace-client/conventions-collectives/${this.convention.conventionId}/${this.variant.variantNumber}`;
        },
        className() {
            return `convention-teaser-action ${this.mode} ${this.selected ? "selected" : ""}`;
        },
        name() {
            return this.mode == "search-result" || this.mode == "dashboard"
                ? "light"
                : "light-outlined";
        },
    },
    methods: {
        scrollTop() {
            scrollManager.scrollTop();
        },
        openInfoVns() {
            EventBus.$emit("linked-content:show", this.variant.variantNumber);
        },
        enter() {
            this.showTooltip = true;
            this.$emit("type-mouseover", this.variant.type);
        },
        leave() {
            this.showTooltip = false;
        },
    },
};
</script>

<style lang="sass">
a
    text-decoration: none
::v-deep .chevron
    transition: transform .15s ease

.selected
    ::v-deep .chevron
        transform: rotate(90deg)

.search-result
    ::v-deep .chevron
        transform: none !important

.dashboard
    ::v-deep .chevron
        transform: none !important


.button-container
    position: relative
    z-index: 5

.container-tooltip
    position: relative

.content-tooltip
    position: absolute
    width: 300px
    bottom: 100%
    margin-bottom: 5px
    color: white
    background-color: rgba(grey, 0.9)
    border-radius: 5px
    padding: 10px
    &:after
        content: ""
        position: absolute
        left: -5px
        top: 0
        bottom: -50px
        width: var(--tooltipWidth)
        z-index: 1 !important

.my-transition
    &-enter-active, &-leave, &-leave-to
        transition: transform 100ms ease-in, opacity 100ms ease-in

    &-enter, &-leave-to
        opacity: 0
        transform: translate(0, 5px)

@media print
    ::v-deep .chevron
        display: none
    .convention-teaser-action:not(.selected)
        display: none
</style>
